(() => {
  if (customElements.get('zoka-price-signals')) return;
  customElements.define('zoka-price-signals', class extends HTMLElement {
    connectedCallback() {
      this.initialized = false;
      this.initialize();
      if (!this.initialized) {
        this.observer = new MutationObserver(() => this.initialize());
        this.observer.observe(this, {childList: true, subtree: true});
      }
    }
    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.viewport = this.querySelector('.zoka-price-signals__viewport');
      this.toggle = this.querySelector('button');
      if (!this.viewport || !this.toggle) return;
      this.initialized = true;
      this.observer?.disconnect();
      this.messages = [];
      this.paused = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      document.addEventListener('variant:change', event => {
        if (event.target.closest('.shopify-section') !== this.closest('.shopify-section')) return;
        this.selectVariant(event.detail?.variant?.id);
      }, options);
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateToggle();
      }, options);
      this.reduced.addEventListener('change', () => this.updateMessages(), options);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.removeExpired();
      }, options);
      this.updateMessages();
      this.timer = setInterval(() => {
        if (!this.isConnected || document.hidden) return;
        this.removeExpired();
        if (this.paused || this.reduced.matches || this.messages.length < 2) return;
        this.index = (this.index + 1) % this.messages.length;
        this.paint();
      }, 4500);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.initialized = false;
      this.abort?.abort();
      this.classList.remove('zoka-price-signals--ready');
    }
    selectVariant(id) {
      const template = Array.from(this.querySelectorAll('template')).find(item => item.dataset.signalVariant === String(id));
      if (template) {
        this.viewport.replaceChildren(template.content.cloneNode(true));

        this.dataset.variant = String(id);
      } else {
        Array.from(this.viewport.children).filter(item => item.dataset.kind !== 'vat').forEach(item => item.remove());
        this.dataset.variant = '';
      }
      this.updateMessages();
    }
    removeExpired() {
      const now = Date.now() / 1000;
      const expired = Array.from(this.viewport.children).filter(item => item.dataset.expires && Number(item.dataset.expires) <= now);
      if (!expired.length) return;
      expired.forEach(item => item.remove());
      this.updateMessages();
    }
    updateMessages() {
      this.messages = Array.from(this.viewport.children);
      this.index = 0;
      this.toggle.hidden = this.messages.length < 2 || this.reduced.matches;
      this.classList.toggle('zoka-price-signals--static', this.reduced.matches);
      this.updateToggle();
      this.paint();
      this.classList.add('zoka-price-signals--ready');
    }
    updateToggle() {
      this.toggle.setAttribute('aria-pressed', String(this.paused));
      this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.toggle.innerHTML = this.paused
        ? '<svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><path d="m3 1 8 5-8 5z"/></svg>'
        : '<svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><path d="M3 2h2v8H3zm4 0h2v8H7z"/></svg>';
    }
    paint() {
      this.messages.forEach((item, index) => {
        item.classList.toggle('is-active', index === this.index);
        const hidden = !this.reduced.matches && index !== this.index;
        item.setAttribute('aria-hidden', String(hidden));
        if (item.matches('a')) item.tabIndex = hidden ? -1 : 0;
      });
    }
  });
})();
